import React from "react";
import "../../../css/DesignSystem/Stepper/Stepper.css";

const Stepper = ({ steps = [], activeStep = 0, onStepChange }) => (
  <ol className="stepper" aria-label="Progress">
    {steps.map((step, index) => {
      const label = typeof step === "string" ? step : step.label;
      const id = typeof step === "string" ? step : step.id;
      const state = index === activeStep
        ? "is-active"
        : index < activeStep
          ? "is-complete"
          : "";
      const labelClassName = index === activeStep
        ? "stepper-label FP_Subtitle_Semibold text-primary-1"
        : index < activeStep
          ? "stepper-label FP_Subtitle text-primary-1"
          : "stepper-label FP_Subtitle text-grey";

      return (
        <li className={state} key={id || label}>
          <button
            aria-current={index === activeStep ? "step" : undefined}
            disabled={!onStepChange}
            onClick={() => onStepChange?.(index)}
            type="button"
          >
            <span className="stepper-number FP_Subtitle">{index + 1}</span>
            <span className={labelClassName}>{label}</span>
          </button>
        </li>
      );
    })}
  </ol>
);

export default Stepper;
